import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ConfigService } from 'src/app/core/services/config.service';
import { FileTypeService } from 'src/app/shared/services/file-type.service';
import { AudanetTask } from '../models/AudanetTask';
import { AudanetTaskAttachments } from '../models/AudanetTaskAttachments';
import { AudanetTaskSearchResultItem } from '../models/AudanetTaskSearchResultItem';
import { SearchAudanetTasksCriteria } from '../models/SearchAudanetTasksCriteria';
import { AudanetDocumentMappingDictionaryItem } from '../models/AudanetDocumentMappingDictionaryItem';
import { AudanetTaskForRegistrationItem } from '../models/AudanetTaskForRegistrationItem';
import { Claim } from '../../claims-data/models/Claim';
import { ExternalDataToRegisterClaim } from '../../claims-data/models/ExternalDataToRegisterClaim';


@Injectable({
  providedIn: 'root'
})
export class AudanetIntegrationService {

  constructor(private http: HttpClient,
    private configService: ConfigService,
    private fileTypeService:FileTypeService) {

  }


  public searchAudanetTasks(searchAudanetTasksCriteria: SearchAudanetTasksCriteria): Observable<AudanetTaskSearchResultItem[]> {
    return this.http.post<AudanetTaskSearchResultItem[]>(
      this.configService.PortalWebApiUrl + 'AudanetTask/searchAudanetTasks', searchAudanetTasksCriteria);
  }

   public getAudanetTasksForClaimRegistration(searchAudanetTasksCriteria: SearchAudanetTasksCriteria): Observable<AudanetTaskForRegistrationItem[]> {
    return this.http.post<AudanetTaskForRegistrationItem[]>(
      this.configService.PortalWebApiUrl + 'AudanetTask/getAudanetTasksForClaimRegistration', searchAudanetTasksCriteria);
  }

  public getClaimRegistrationDataFromAudanetTask(audanetTaskId: string): Observable<ExternalDataToRegisterClaim> {
    return this.http.get<ExternalDataToRegisterClaim>(
      this.configService.PortalWebApiUrl + 'AudanetTask/getClaimRegistrationDataFromAudanetTask/' + audanetTaskId);
  }
  
  public getTask(taskId: string): Observable<AudanetTask> {
    return this.http.get<AudanetTask>(
      this.configService.PortalWebApiUrl + 'AudanetTask/getTask/' + taskId);
  }

  public getMappingDictionary(memberId: string): Observable<AudanetDocumentMappingDictionaryItem[]> {
    return this.http.get<AudanetDocumentMappingDictionaryItem[]>(
      this.configService.PortalWebApiUrl + 'AudanetTask/getMappingDictionary/' + memberId);
  }

  public addAttachments(attachments: AudanetTaskAttachments): Observable<number> {
    return this.http.post<number>(
      this.configService.PortalWebApiUrl + 'AudanetTask/addAttachments', attachments);
  }

  public base64toBlob(base64Data, fileExtension='', sliceSize=512): Blob  {
    const byteCharacters = atob(base64Data);
    const byteArrays = [];
  
    const contentType:string= this.fileTypeService.getContentType(fileExtension);

    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      const slice = byteCharacters.slice(offset, offset + sliceSize);
  
      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }
  
      const byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }
  
    const blob = new Blob(byteArrays, {type: contentType});
    return blob;
  }

}
